// La Liga 2026/27 fixtures — season released 30 June 2026 (RFEF).
// Exact match days/kick-off times are only confirmed ~3 weeks before each round.
// wc = week commencing date (Monday that opens the fixture round).

const HOME_SPOTLIGHT = new Set(['Elche', 'Valencia', 'Levante']);

// [matchday, [year, month0, day], [[home, away], ...]]
const RAW = [
  [1, [2026,7,16], [
    ['Alavés','Getafe'],['Atlético Madrid','Málaga'],['Celta Vigo','Osasuna'],
    ['Deportivo La Coruña','Elche'],['Espanyol','Levante'],['Barcelona','Athletic Bilbao'],
    ['Racing Santander','Villarreal'],['Real Madrid','Real Sociedad'],
    ['Sevilla','Rayo Vallecano'],['Valencia','Real Betis'],
  ]],
  [2, [2026,7,23], [
    ['Athletic Bilbao','Sevilla'],['Atlético Madrid','Villarreal'],
    ['Real Betis','Real Sociedad'],['Elche','Barcelona'],['Espanyol','Real Madrid'],
    ['Getafe','Racing Santander'],['Málaga','Deportivo La Coruña'],['Osasuna','Levante'],
    ['Rayo Vallecano','Alavés'],['Valencia','Celta Vigo'],
  ]],
  [3, [2026,7,30], [
    ['Alavés','Villarreal'],['Celta Vigo','Athletic Bilbao'],
    ['Deportivo La Coruña','Valencia'],['Barcelona','Rayo Vallecano'],
    ['Levante','Real Betis'],['Osasuna','Getafe'],['Racing Santander','Elche'],
    ['Real Madrid','Málaga'],['Real Sociedad','Espanyol'],['Sevilla','Atlético Madrid'],
  ]],
  [4, [2026,8,6], [
    ['Alavés','Osasuna'],['Athletic Bilbao','Atlético Madrid'],['Real Betis','Real Madrid'],
    ['Elche','Real Sociedad'],['Espanyol','Sevilla'],['Getafe','Celta Vigo'],
    ['Málaga','Levante'],['Rayo Vallecano','Racing Santander'],['Valencia','Barcelona'],
    ['Villarreal','Deportivo La Coruña'],
  ]],
  [5, [2026,8,13], [
    ['Athletic Bilbao','Elche'],['Celta Vigo','Málaga'],['Getafe','Deportivo La Coruña'],
    ['Levante','Barcelona'],['Osasuna','Espanyol'],['Racing Santander','Alavés'],
    ['Real Madrid','Rayo Vallecano'],['Real Sociedad','Atlético Madrid'],
    ['Sevilla','Valencia'],['Villarreal','Real Betis'],
  ]],
  [6, [2026,8,16], [
    ['Alavés','Valencia'],['Atlético Madrid','Osasuna'],['Real Betis','Getafe'],
    ['Deportivo La Coruña','Sevilla'],['Elche','Real Madrid'],['Barcelona','Racing Santander'],
    ['Levante','Athletic Bilbao'],['Málaga','Villarreal'],['Rayo Vallecano','Espanyol'],
    ['Real Sociedad','Celta Vigo'],
  ]],
  [7, [2026,8,20], [
    ['Athletic Bilbao','Alavés'],['Atlético Madrid','Real Madrid'],
    ['Celta Vigo','Racing Santander'],['Deportivo La Coruña','Real Betis'],
    ['Espanyol','Elche'],['Getafe','Málaga'],['Osasuna','Rayo Vallecano'],
    ['Sevilla','Barcelona'],['Valencia','Real Sociedad'],['Villarreal','Levante'],
  ]],
  [8, [2026,9,11], [
    ['Alavés','Atlético Madrid'],['Real Betis','Osasuna'],['Elche','Celta Vigo'],
    ['Barcelona','Getafe'],['Levante','Sevilla'],['Málaga','Espanyol'],
    ['Racing Santander','Valencia'],['Rayo Vallecano','Athletic Bilbao'],
    ['Real Madrid','Villarreal'],['Real Sociedad','Deportivo La Coruña'],
  ]],
  [9, [2026,9,18], [
    ['Real Betis','Barcelona'],['Celta Vigo','Alavés'],['Deportivo La Coruña','Levante'],
    ['Espanyol','Atlético Madrid'],['Getafe','Rayo Vallecano'],['Málaga','Real Sociedad'],
    ['Osasuna','Racing Santander'],['Real Madrid','Sevilla'],['Valencia','Athletic Bilbao'],
    ['Villarreal','Elche'],
  ]],
  [10, [2026,9,25], [
    ['Alavés','Málaga'],['Athletic Bilbao','Getafe'],['Atlético Madrid','Deportivo La Coruña'],
    ['Celta Vigo','Real Betis'],['Barcelona','Real Madrid'],['Racing Santander','Espanyol'],
    ['Rayo Vallecano','Elche'],['Real Sociedad','Levante'],['Sevilla','Osasuna'],
    ['Valencia','Villarreal'],
  ]],
  [11, [2026,10,1], [
    ['Athletic Bilbao','Real Sociedad'],['Real Betis','Málaga'],['Deportivo La Coruña','Osasuna'],
    ['Elche','Valencia'],['Barcelona','Alavés'],['Getafe','Sevilla'],
    ['Levante','Atlético Madrid'],['Racing Santander','Real Madrid'],
    ['Rayo Vallecano','Celta Vigo'],['Villarreal','Espanyol'],
  ]],
  [12, [2026,10,8], [
    ['Atlético Madrid','Barcelona'],['Celta Vigo','Levante'],['Elche','Real Betis'],
    ['Espanyol','Deportivo La Coruña'],['Málaga','Racing Santander'],
    ['Osasuna','Athletic Bilbao'],['Real Sociedad','Rayo Vallecano'],['Sevilla','Alavés'],
    ['Valencia','Real Madrid'],['Villarreal','Getafe'],
  ]],
  [13, [2026,10,22], [
    ['Alavés','Deportivo La Coruña'],['Athletic Bilbao','Espanyol'],['Barcelona','Villarreal'],
    ['Getafe','Atlético Madrid'],['Levante','Elche'],['Osasuna','Málaga'],
    ['Racing Santander','Real Sociedad'],['Rayo Vallecano','Valencia'],
    ['Real Madrid','Celta Vigo'],['Sevilla','Real Betis'],
  ]],
  [14, [2026,10,29], [
    ['Real Betis','Rayo Vallecano'],['Celta Vigo','Villarreal'],
    ['Deportivo La Coruña','Barcelona'],['Elche','Atlético Madrid'],
    ['Espanyol','Getafe'],['Levante','Racing Santander'],['Málaga','Athletic Bilbao'],
    ['Real Madrid','Alavés'],['Real Sociedad','Sevilla'],['Valencia','Osasuna'],
  ]],
  [15, [2026,11,6], [
    ['Alavés','Espanyol'],['Athletic Bilbao','Real Madrid'],['Atlético Madrid','Real Betis'],
    ['Barcelona','Celta Vigo'],['Getafe','Valencia'],['Osasuna','Elche'],
    ['Racing Santander','Deportivo La Coruña'],['Rayo Vallecano','Levante'],
    ['Sevilla','Málaga'],['Villarreal','Real Sociedad'],
  ]],
  [16, [2026,11,13], [
    ['Atlético Madrid','Valencia'],['Real Betis','Racing Santander'],
    ['Deportivo La Coruña','Athletic Bilbao'],['Elche','Sevilla'],['Espanyol','Celta Vigo'],
    ['Levante','Alavés'],['Málaga','Barcelona'],['Real Madrid','Osasuna'],
    ['Real Sociedad','Getafe'],['Villarreal','Rayo Vallecano'],
  ]],
  [17, [2026,11,20], [
    ['Alavés','Elche'],['Athletic Bilbao','Real Betis'],['Celta Vigo','Atlético Madrid'],
    ['Deportivo La Coruña','Real Madrid'],['Barcelona','Real Sociedad'],
    ['Getafe','Levante'],['Osasuna','Villarreal'],['Rayo Vallecano','Málaga'],
    ['Sevilla','Racing Santander'],['Valencia','Espanyol'],
  ]],
  [18, [2027,0,3], [
    ['Real Betis','Alavés'],['Celta Vigo','Deportivo La Coruña'],['Espanyol','Barcelona'],
    ['Levante','Valencia'],['Málaga','Elche'],['Racing Santander','Athletic Bilbao'],
    ['Rayo Vallecano','Atlético Madrid'],['Real Madrid','Getafe'],
    ['Real Sociedad','Osasuna'],['Villarreal','Sevilla'],
  ]],
  [19, [2027,0,10], [
    ['Alavés','Real Sociedad'],['Athletic Bilbao','Villarreal'],
    ['Atlético Madrid','Racing Santander'],['Deportivo La Coruña','Rayo Vallecano'],
    ['Elche','Getafe'],['Espanyol','Real Betis'],['Osasuna','Barcelona'],
    ['Real Madrid','Levante'],['Sevilla','Celta Vigo'],['Valencia','Málaga'],
  ]],
  [20, [2027,0,17], [
    ['Atlético Madrid','Real Sociedad'],['Real Betis','Deportivo La Coruña'],
    ['Celta Vigo','Valencia'],['Barcelona','Elche'],['Getafe','Athletic Bilbao'],
    ['Levante','Espanyol'],['Málaga','Real Madrid'],['Racing Santander','Osasuna'],
    ['Rayo Vallecano','Sevilla'],['Villarreal','Alavés'],
  ]],
  [21, [2027,0,24], [
    ['Alavés','Barcelona'],['Athletic Bilbao','Levante'],
    ['Deportivo La Coruña','Atlético Madrid'],['Elche','Rayo Vallecano'],
    ['Espanyol','Villarreal'],['Getafe','Osasuna'],['Racing Santander','Celta Vigo'],
    ['Real Madrid','Real Betis'],['Real Sociedad','Málaga'],['Valencia','Sevilla'],
  ]],
  [22, [2027,0,31], [
    ['Atlético Madrid','Espanyol'],['Real Betis','Elche'],['Celta Vigo','Getafe'],
    ['Barcelona','Valencia'],['Levante','Real Sociedad'],['Málaga','Alavés'],
    ['Osasuna','Deportivo La Coruña'],['Rayo Vallecano','Real Madrid'],
    ['Sevilla','Athletic Bilbao'],['Villarreal','Racing Santander'],
  ]],
  [23, [2027,1,7], [
    ['Alavés','Celta Vigo'],['Athletic Bilbao','Osasuna'],['Real Betis','Sevilla'],
    ['Deportivo La Coruña','Málaga'],['Elche','Levante'],['Espanyol','Rayo Vallecano'],
    ['Barcelona','Atlético Madrid'],['Getafe','Villarreal'],
    ['Real Sociedad','Real Madrid'],['Valencia','Racing Santander'],
  ]],
  [24, [2027,1,14], [
    ['Celta Vigo','Rayo Vallecano'],['Elche','Deportivo La Coruña'],['Levante','Málaga'],
    ['Osasuna','Atlético Madrid'],['Racing Santander','Getafe'],
    ['Real Madrid','Athletic Bilbao'],['Real Sociedad','Real Betis'],['Sevilla','Espanyol'],
    ['Valencia','Alavés'],['Villarreal','Barcelona'],
  ]],
  [25, [2027,1,21], [
    ['Alavés','Racing Santander'],['Athletic Bilbao','Celta Vigo'],
    ['Atlético Madrid','Elche'],['Deportivo La Coruña','Real Sociedad'],
    ['Espanyol','Osasuna'],['Barcelona','Levante'],['Málaga','Real Betis'],
    ['Rayo Vallecano','Getafe'],['Sevilla','Real Madrid'],['Villarreal','Valencia'],
  ]],
  [26, [2027,1,28], [
    ['Athletic Bilbao','Barcelona'],['Real Betis','Villarreal'],['Celta Vigo','Espanyol'],
    ['Getafe','Alavés'],['Levante','Deportivo La Coruña'],['Málaga','Atlético Madrid'],
    ['Osasuna','Sevilla'],['Racing Santander','Rayo Vallecano'],
    ['Real Madrid','Valencia'],['Real Sociedad','Elche'],
  ]],
  [27, [2027,2,7], [
    ['Alavés','Athletic Bilbao'],['Atlético Madrid','Celta Vigo'],
    ['Deportivo La Coruña','Getafe'],['Elche','Málaga'],['Espanyol','Racing Santander'],
    ['Barcelona','Real Betis'],['Rayo Vallecano','Osasuna'],['Sevilla','Real Sociedad'],
    ['Valencia','Levante'],['Villarreal','Real Madrid'],
  ]],
  [28, [2027,2,14], [
    ['Alavés','Sevilla'],['Athletic Bilbao','Valencia'],['Real Betis','Levante'],
    ['Elche','Villarreal'],['Barcelona','Deportivo La Coruña'],['Getafe','Real Sociedad'],
    ['Málaga','Rayo Vallecano'],['Osasuna','Celta Vigo'],
    ['Racing Santander','Atlético Madrid'],['Real Madrid','Espanyol'],
  ]],
  [29, [2027,2,21], [
    ['Atlético Madrid','Getafe'],['Celta Vigo','Real Madrid'],['Espanyol','Athletic Bilbao'],
    ['Levante','Osasuna'],['Racing Santander','Real Betis'],['Rayo Vallecano','Barcelona'],
    ['Real Sociedad','Alavés'],['Sevilla','Elche'],['Valencia','Deportivo La Coruña'],
    ['Villarreal','Málaga'],
  ]],
  [30, [2027,3,4], [
    ['Athletic Bilbao','Racing Santander'],['Real Betis','Celta Vigo'],
    ['Deportivo La Coruña','Villarreal'],['Elche','Alavés'],['Barcelona','Sevilla'],
    ['Getafe','Espanyol'],['Levante','Rayo Vallecano'],['Málaga','Osasuna'],
    ['Real Madrid','Atlético Madrid'],['Real Sociedad','Valencia'],
  ]],
  [31, [2027,3,11], [
    ['Alavés','Real Betis'],['Atlético Madrid','Levante'],['Celta Vigo','Elche'],
    ['Espanyol','Málaga'],['Osasuna','Real Madrid'],['Racing Santander','Barcelona'],
    ['Rayo Vallecano','Real Sociedad'],['Sevilla','Deportivo La Coruña'],
    ['Valencia','Getafe'],['Villarreal','Athletic Bilbao'],
  ]],
  [32, [2027,3,18], [
    ['Alavés','Rayo Vallecano'],['Atlético Madrid','Sevilla'],['Real Betis','Athletic Bilbao'],
    ['Deportivo La Coruña','Celta Vigo'],['Elche','Osasuna'],['Barcelona','Espanyol'],
    ['Getafe','Real Madrid'],['Levante','Villarreal'],['Málaga','Valencia'],
    ['Real Sociedad','Racing Santander'],
  ]],
  [33, [2027,3,21], [
    ['Athletic Bilbao','Deportivo La Coruña'],['Celta Vigo','Barcelona'],
    ['Espanyol','Real Sociedad'],['Getafe','Real Betis'],['Osasuna','Alavés'],
    ['Racing Santander','Málaga'],['Real Madrid','Elche'],['Sevilla','Levante'],
    ['Valencia','Rayo Vallecano'],['Villarreal','Atlético Madrid'],
  ]],
  [34, [2027,4,2], [
    ['Atlético Madrid','Alavés'],['Real Betis','Valencia'],['Celta Vigo','Sevilla'],
    ['Deportivo La Coruña','Racing Santander'],['Elche','Espanyol'],['Barcelona','Osasuna'],
    ['Levante','Real Madrid'],['Málaga','Getafe'],['Rayo Vallecano','Villarreal'],
    ['Real Sociedad','Athletic Bilbao'],
  ]],
  [35, [2027,4,9], [
    ['Alavés','Levante'],['Athletic Bilbao','Málaga'],['Real Betis','Espanyol'],
    ['Getafe','Elche'],['Osasuna','Real Sociedad'],['Racing Santander','Sevilla'],
    ['Rayo Vallecano','Deportivo La Coruña'],['Real Madrid','Barcelona'],
    ['Valencia','Atlético Madrid'],['Villarreal','Celta Vigo'],
  ]],
  [36, [2027,4,16], [
    ['Atlético Madrid','Rayo Vallecano'],['Deportivo La Coruña','Alavés'],
    ['Elche','Athletic Bilbao'],['Espanyol','Valencia'],['Levante','Getafe'],
    ['Málaga','Celta Vigo'],['Osasuna','Real Betis'],['Real Madrid','Racing Santander'],
    ['Real Sociedad','Barcelona'],['Sevilla','Villarreal'],
  ]],
  [37, [2027,4,23], [
    ['Alavés','Real Madrid'],['Atlético Madrid','Athletic Bilbao'],
    ['Celta Vigo','Real Sociedad'],['Deportivo La Coruña','Espanyol'],
    ['Barcelona','Málaga'],['Racing Santander','Levante'],['Rayo Vallecano','Real Betis'],
    ['Sevilla','Getafe'],['Valencia','Elche'],['Villarreal','Osasuna'],
  ]],
  [38, [2027,4,30], [
    ['Athletic Bilbao','Rayo Vallecano'],['Real Betis','Atlético Madrid'],
    ['Elche','Racing Santander'],['Espanyol','Alavés'],['Getafe','Barcelona'],
    ['Levante','Celta Vigo'],['Málaga','Sevilla'],['Osasuna','Valencia'],
    ['Real Madrid','Deportivo La Coruña'],['Real Sociedad','Villarreal'],
  ]],
];

export const LALIGA_FIXTURES = RAW.map(([matchday, [y, m, d], pairs]) => ({
  matchday,
  wc: new Date(y, m, d),
  wcLabel: new Date(y, m, d).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }),
  matches: pairs.map(([home, away]) => ({ home, away, highlight: HOME_SPOTLIGHT.has(home) })),
}));

/**
 * Returns matchdays whose fixture week overlaps the given trip window.
 * tripStart: Date object for departure / check-in day.
 * tripNights: number of nights (2 or 3, defaults to 3 if unset).
 */
export function findMatchingFixtures(tripStart, tripNights) {
  if (!tripStart || !(tripStart instanceof Date) || isNaN(tripStart.getTime())) return [];
  const DAY = 86400000;
  const startMs = tripStart.getTime();
  const endMs = startMs + ((tripNights || 3) * DAY);
  const buffer = 2 * DAY;
  return LALIGA_FIXTURES.filter(({ wc }) => {
    const ms = wc.getTime();
    return ms >= startMs - buffer && ms <= endMs + buffer;
  });
}
